'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _util = require('./util');

var _props5 = require('../props');

var _customList = require('./custom-list.js');

var _customList2 = _interopRequireDefault(_customList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions

function escapeRegExp(src) {
  // 将输入转成字符串
  var stringifiedSrc = '' + src;
  return stringifiedSrc.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched ring
}

var Options = function (_Component) {
  _inherits(Options, _Component);

  function Options(props, context) {
    _classCallCheck(this, Options);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.state = { localFilterDataSource: null };
    _this.dataSource = [];
    _this.handleScrollEvent = (0, _lodash.debounce)(_this.handleScrollEvent.bind(_this), 200);
    _this.handleSearchValueChange = (0, _lodash.debounce)(_this.handleSearchValueChange.bind(_this), 1000);
    _this.handleSelectItem = _this.handleSelectItem.bind(_this);
    return _this;
  }

  Options.prototype.componentDidMount = function componentDidMount() {
    if (this.scrollParent && this.props.lazyLoad) {
      this.scrollComponent.addEventListener('scroll', this.handleScrollEvent);
    }
  };

  Options.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var visible = this.props.visible;
    var nextVisible = nextProps.visible;
    // switch visible from false to true, should clear search local DataSource

    if (nextVisible !== visible && nextVisible) {
      this.setState({ localFilterDataSource: null });
    }
  };

  Options.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var visible = this.props.visible;
    var nextVisible = nextProps.visible;

    if (nextVisible === visible && !nextVisible) {
      return false;
    }
    return true;
  };

  Options.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.scrollParent && this.props.lazyLoad) {
      this.scrollComponent.removeEventListener('scroll', this.handleScrollEvent);
    }
  };

  Options.prototype.handleScrollEvent = function handleScrollEvent() {
    var _props = this.props,
        threshold = _props.threshold,
        onLoadMore = _props.onLoadMore,
        showSearch = _props.showSearch;
    var clientHeight = this.scrollParent.clientHeight;

    var _ref = this.searchComponent || { clientHeight: 0 },
        searchHeight = _ref.clientHeight;

    var _scrollComponent = this.scrollComponent,
        scrollHeight = _scrollComponent.scrollHeight,
        scrollTop = _scrollComponent.scrollTop;

    var offsetBottom = scrollHeight - scrollTop - (clientHeight - searchHeight - 20);

    if (offsetBottom <= threshold) {
      onLoadMore();
    }
  };

  Options.prototype.handleSearchValueChange = function handleSearchValueChange(value) {
    var _props2 = this.props,
        dataSource = _props2.dataSource,
        searchLocal = _props2.searchLocal,
        onSearchChange = _props2.onSearchChange;


    if (searchLocal) {
      var filterData = [];

      if (dataSource && dataSource.length > 0) {
        var reg = new RegExp(escapeRegExp(value), 'i');
        dataSource.forEach(function (item) {
          if (reg.test('' + item.text)) {
            filterData.push(item);
          }
        });
      }
      this.setState({ localFilterDataSource: filterData });
    } else {
      onSearchChange(value);
    }
  };

  // handleItemSelect callback including selected or unselected element


  Options.prototype.handleSelectItem = function handleSelectItem(item) {
    var _props3 = this.props,
        multiple = _props3.multiple,
        dataSource = _props3.dataSource,
        value = _props3.value,
        onChange = _props3.onChange,
        useDetailValue = _props3.useDetailValue;

    onChange((0, _util.getNextValue)(value, dataSource, multiple, item, useDetailValue));
  };

  Options.prototype.render = function render() {
    var _this2 = this;

    var _props4 = this.props,
        loading = _props4.loading,
        showSearch = _props4.showSearch,
        className = _props4.className,
        dataSource = _props4.dataSource,
        value = _props4.value,
        notFoundContent = _props4.notFoundContent;

    var renderDataSource = this.state.localFilterDataSource || dataSource;

    return _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)('sell-o-select-options', className, { active: loading }),
        ref: function ref(node) {
          _this2.scrollParent = node;
        }
      },
      showSearch ? _react2.default.createElement(
        'div',
        {
          className: 'options-search',
          ref: function ref(node) {
            _this2.searchComponent = node;
          }
        },
        _react2.default.createElement(_next.Input, { size: 'small', onChange: this.handleSearchValueChange }),
        _react2.default.createElement(_next.Icon, { type: 'search', size: 'xs', className: 'search-icon' })
      ) : null,
      _react2.default.createElement(
        'div',
        {
          className: 'options-content',
          ref: function ref(node) {
            _this2.scrollComponent = node;
          }
        },
        (0, _lodash.isEmpty)(dataSource) ? _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('empty-content', className) },
          notFoundContent
        ) : _react2.default.createElement(_customList2.default, { dataSource: renderDataSource, value: value, onClick: this.handleSelectItem })
      ),
      _react2.default.createElement(
        'div',
        { className: 'loading' },
        _react2.default.createElement(_next.Icon, { type: 'loading' })
      )
    );
  };

  return Options;
}(_react.Component);

exports.default = Options;


Options.displayName = 'SellOSelectOptions';
Options.propTypes = _extends({}, _props5.propTypes, {
  visible: _propTypes2.default.bool
});
Options.defaultProps = _extends({}, _props5.defaultProps, {
  visible: false
});
module.exports = exports['default'];